import { Col, Row } from 'react-bootstrap';
import { CategoryList } from '../../views/menu/category/CategoryList';
export function MenuCategory() {
  return (
    <>
      <Row>
        <Col xs={12}>
          <CategoryList />
        </Col>
      </Row>
    </>
  );
}
